module.exports = __webpack_public_path__ + "static/img/10.7bdf0376.png";